import { Dialog } from '@kiwicom/orbit-components';
import type { Props as OrbitProps } from '@kiwicom/orbit-components/lib/Dialog/types';

type Props = Readonly<
  OrbitProps & {
    readonly isVisible: boolean;
  }
>;

const AccountDialog = ({ isVisible, ...rest }: Props): JSX.Element | null => {
  if (!isVisible) {
    return null;
  }

  return <Dialog {...rest} />;
};

export default AccountDialog;
